<template>
  <div class="home">
    <Snack :active="activeSnack" :duration="5000" :msg="msgSnack" @deactivate="activeSnack = false" :color="color" />
    <span class="logout" @click="logout">Logout</span>
    <Card @openModal="open" :company="company" />
    <Backdrop v-if="infoActive || modalOpen" @backClicked="modalOpen = false" />
    <Modal v-if="modalOpen" :msg="msg" :action="act" @cancelModal="modalOpen = false" @flowAction="flowAction" />
    <InfoBox :infoActive="infoActive" />
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import Card from "@/components/Card";
import InfoBox from "@/components/InfoBox";
import Backdrop from "@/components/BackDrop";
import Snack from "@/components/Snack";
import Connect from "aws-sdk/clients/connect";
import { mapState } from "vuex";

export default {
  name: "home",
  components: {
    Card,
    InfoBox,
    Backdrop,
    Modal,
    Snack,
  },
  data() {
    return {
      infoActive: true,
      modalOpen: false,
      params: {
        InstanceId: "ca8fecf9-5342-4148-af57-14efbeef2e85",
        ContactFlowTypes: ["CONTACT_FLOW"],
        MaxResults: "1000",
      },
      flows: [],
      action: "",
      activeSnack: false,
      msgSnack: "",
      color: "",
      company:"",
    };
  },

  computed: {
    msg() {
      return `Sei sicuro di voler ${this.action} tutte le linee  attive?`;
    },
    act() {
      return this.action == "chiudere" ? "close" : "open";
    },
    company() {
      return localStorage.getItem("company");
    },
    ...mapState(["username", "access_key", "secret_access_key"]),
  },
  async mounted() {
    setTimeout(() => {
      this.infoActive = false;
    }, 5000);

    const connect = new Connect({
      region: "eu-central-1",
      credentials: {
        accessKeyId: this.access_key,
        secretAccessKey: this.secret_access_key,
      },
    });

    const flows = await connect.listContactFlows(this.params).promise();

    this.flows = flows.ContactFlowSummaryList.filter((f) =>
      f.Name.startsWith("GI_")
    );
  },

  methods: {
    open(action) {
      this.modalOpen = true;
      this.action = action;
    },
    logout() {
      this.$router.push({
        path: "/",
      });
      this.$store.commit("cleanAuth");
    },
    async flowAction() {
      var apigClient = apigClientFactory.newClient({
        accessKey: this.access_key,
        secretKey: this.secret_access_key,
        region: "eu-central-1",
      });

      console.log("username: ", this.username);
      let company = this.company();

      if (company == 'generali') {
        this.company = 'GI'
      } else {
       this.company = 'WE'
      }
       console.log("company: ", this.company);
      var body = {
        company: this.company, //this.company == 'generali' ? 'GI' : 'WE',
        name: this.username,
      };
      console.log("QUESTO===>>> ", body);

      try {
        if (this.act == "close") {
          this.modalOpen = false;
          await apigClient.closePost(null, body);
          this.color = "success";
          this.activeSnack = true;
          this.msgSnack = "Alberi chiusi con successo";
        } else {
          this.modalOpen = false;
          await apigClient.openPost(null, body);
          this.color = "success";
          this.activeSnack = true;
          this.msgSnack = "Alberi riaperti con successo";
        }
      } catch (e) {
        this.color = "error";
        this.activeSnack = true;
        this.msgSnack = "Si è verificato un errore";
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
.home {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
}

.logout {
  position: absolute;
  left: 10px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}
</style>
